import React from 'react'
import Modal from 'react-bootstrap/Modal';
import ReactApexChart from "react-apexcharts";
import Tooltip from "@mui/material/Tooltip";
import useWindowDimensions, { humanReadable } from '../../../../../../utils/useWindowDimensions';
import { CloseIcon, EnlargeIcon } from '../../../../../../assets/icons/iconshere';

const LargeErrorChart = ({errorSpider,errorEnlarge, setErrorEnlarge }) => {
    let { width, height } = useWindowDimensions();
    
    const chartData = {
        series: [
            {
                name: 'First Iteration',
                data: errorSpider.map((e) => e.first),
            },
            {
                name: 'Last Iteration',
                data: errorSpider.map((e) => e.last),
            },
        ],
        options: {
            chart: {
                type: 'radar',
                toolbar: {
                    show: false,
                },
            },
            dataLabels: {
                enabled: true,
            },
            plotOptions: {
                radar: {
                    size: 150,
                    polygons: {
                        strokeColors: '#e9e9e9',
                        fill: {
                            colors: ['#f8f8f8', '#fff']
                        }
                    }
                }
            },
            colors: ['#3e4095', '#333333'],
            markers: {
                size: 5,
                colors: ['#fff'],
                strokeColor: '#3e4095CC',
                strokeWidth: 1,
            },
            tooltip: {
                x: {
                    formatter: (value, { dataPointIndex }) => {
                        const name = errorSpider[dataPointIndex].name;
                        return `${name}`;
                    }
                },
                y: {
                    formatter: (value) => {
                        return `${humanReadable(value)}`;
                    }
                }
            },
            xaxis: {
                categories: errorSpider.map(e => e.name.split(" ")[0])
            },
            yaxis: {
                tickAmount: 8,
                labels: {
                    formatter: function (val, i) {
                        if (i % 2 === 0) {
                            return val;
                        } else {
                            return '';
                        }
                    }
                }
            }
        }
    };

  return (

    <>
      <Modal size='xl' centered show={errorEnlarge} onHide={()=>setErrorEnlarge(false)}>
        <Modal.Body>
 <div className="cardbox overflow-hidden">
                <div className='d-flex justify-content-between align-items-center mt-1'>
                    <h5 className='mb-1'>Errors</h5>
                </div>
                <div id="chart">
                    <ReactApexChart 
                        options={chartData.options} 
                        series={chartData.series} 
                        type="radar" 
                        height={420} 
                        width="100%" 
                    />
                </div>
            </div>
            <span className='close-icon' onClick={()=>setErrorEnlarge(false)}>
            <CloseIcon/>  
            </span>  
        </Modal.Body>
      </Modal>
    </>
  )
}

export default LargeErrorChart
